import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, CartesianGrid, ReferenceLine, Tooltip } from 'recharts';
import { Typography, Dialog, DialogTitle, DialogContent } from '@mui/material';
import Container from './styles/Container';
import { formatTimeToHHmm } from '../../utils';
import CustomTooltip from './CustomTooltip/CustomTooltip';
import { WAREHOUSE_CHART_COLOR } from '../../constants';

export default function ElevatorChart({ name, data, planVolume, vehicles, open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {name}
        <br />
        График готовой продукции, т
      </DialogTitle>
      <DialogContent>
        <Container>
          {!data || !data.length ? (
            <Typography>Данные для отображения графика отсутствуют</Typography>
          ) : (
            <ResponsiveContainer width="100%" maxHeight="100%">
              <BarChart data={data} barCategoryGap="5%">
                <CartesianGrid strokeDasharray="3 3" />

                <XAxis dataKey="x" tickFormatter={formatTimeToHHmm} type="category" />

                <YAxis
                  tickFormatter={(value) => Number(value.toFixed(2))}
                  domain={[0, Math.ceil((Math.max(...(data ?? []).map((d) => d.y), planVolume) * 1.1) / 10) * 10]}
                />

                <Tooltip content={<CustomTooltip vehicles={vehicles} />} />

                <Bar dataKey="y" fill={WAREHOUSE_CHART_COLOR} />

                {planVolume && (
                  <ReferenceLine
                    y={planVolume}
                    stroke="black"
                    label={{
                      value: `План: ${Number(planVolume.toFixed(2))}`,
                      position: 'top',
                      fontWeight: 'bold',
                      fill: 'black',
                      fontSize: 18,
                    }}
                    strokeWidth={1.5}
                  />
                )}
              </BarChart>
            </ResponsiveContainer>
          )}
        </Container>
      </DialogContent>
    </Dialog>
  );
}

ElevatorChart.propTypes = {
  name: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.string.isRequired,
      y: PropTypes.number.isRequired,
      vehicleId: PropTypes.number.isRequired,
    }),
  ),
  planVolume: PropTypes.number,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  vehicles: PropTypes.arrayOf(PropTypes.shape()),
};
ElevatorChart.defaultProps = {
  name: '',
  data: [],
  planVolume: null,
  vehicles: [],
};
